import { useState, useEffect } from "react";
import { Box, CircularProgress, Grid, Pagination } from "@mui/material";
import { DataGrid, GridCellParams, GridColDef } from "@mui/x-data-grid";
import { getDataSets } from "common-lib";
import PageShell from "../../components/new/PageShell";

export default function DatasetPage() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rows, setRows] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [state, setState] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [keyword, setKeyword] = useState<string | null>(null);
  const columns: GridColDef[] = [
    { field: "id", headerName: "Train ID", width: 100 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "description", headerName: "Description", width: 400 },
    // {
    //   field: "create_at",
    //   headerName: "Date",
    //   width: 200,
    // },
    {
      field: "Labeled / Total",
      headerName: "Labeled / Total",
      width: 200,
      renderCell: (params: any) => (
        <span>
          {params.row.labeled_files} / {params.row.total_files}
        </span>
      ),
    },
  ];
  const modifiedColumns = columns.map((column) => ({
    ...column,
  }));

  useEffect(() => {
    const fetchDataSets = async () => {
      setIsLoading(true);
      try {
        const response = await getDataSets({ page: 1, size: 10 });
        console.log("response", response.dataSets);
        setRows(response.dataSets);
      } catch (error) {
        console.error("Error fetching trains:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchDataSets();
  }, []);

  const handleContextMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    const selectedTrainId = event.currentTarget.getAttribute("data-id");
    setAnchorEl(event.currentTarget);
    setOpen(true);
    // setSelectedTrain(Number(selectedTrainId));
  };
  return (
    <PageShell title="데이터셋 관리">
      <p className="text-gray-600">데이터셋 관리 페이지입니다.</p>
      <>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Grid container sx={{ mt: 3 }}>
              <DataGrid
                hideFooter
                hideFooterPagination
                disableColumnMenu
                disableColumnSorting
                rows={rows}
                columns={modifiedColumns}
                getRowId={(row) => row.id}
                onRowClick={(row) => {
                  console.log(row);
                }}
                slotProps={{
                  row: {
                    onContextMenu: handleContextMenu,
                    style: { cursor: "context-menu" },
                  },
                }}
                // onRowClick={handleRowClick}
                sx={{
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "var(--dg-table-header-bg-color)",
                    color: "#fff",
                  },
                  "& .MuiDataGrid-filler": {
                    backgroundColor: "var(--dg-table-header-bg-color)",
                    color: "#fff",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "bold",
                  },
                  "& .MuiDataGrid-virtualScrollerContent": {
                    backgroundColor: "var(--dk-surface, white)",
                  },
                  "& .MuiDataGrid-cell": {
                    cursor: "pointer",
                    backgroundColor: "var(--unselected-row-bg)",
                    color: "var(--dg-color)",
                  },
                }}
              />

              {/* <MouseClickList
                    anchorEl={anchorEl}
                    open={open}
                    category="train"
                    onClose={handleClose}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                  />
                  {isModalOpen && (
                    <TrainModal
                      open={isModalOpen}
                      onClose={handleCloseModal}
                      state={state}
                      selectTrain={selectedTrain}
                    />
                  )} */}
            </Grid>
            {/* <Pagination
                  count={Math.ceil(total / 10)}
                  page={page}
                  onChange={(_, value) => setPage(value)}
                  color="primary"
                  size="medium"
                  sx={{ mt: 2, display: "flex", justifyContent: "center" }}
                /> */}
          </Box>
        )}
      </>
    </PageShell>
  );
}
